/**
 * AnnouncementBanner - Dynamic announcement banner for dashboard
 */
import { Button } from "@/components/ui/button";
import { Megaphone, ExternalLink, X } from "lucide-react";

export function AnnouncementBanner({ announcement, onDismiss }) {
  if (!announcement) return null;

  return (
    <div
      className="relative bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-lg overflow-hidden shadow-lg"
      data-testid="announcement-banner"
    >
      <div className="px-4 py-3 flex items-center gap-3">
        <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center shrink-0">
          <Megaphone className="h-4 w-4 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-0.5">
            <p className="text-sm font-semibold text-white truncate">
              {announcement.title}
            </p>
            {announcement.badge && (
              <span className="px-1.5 py-0.5 text-[10px] font-bold bg-yellow-400 text-yellow-900 rounded animate-pulse">
                {announcement.badge}
              </span>
            )}
          </div>
          <p className="text-xs text-white/80 truncate">{announcement.description}</p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          {announcement.cta_link && announcement.cta_text && (
            <a
              href={announcement.cta_link}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="announcement-cta"
            >
              <Button
                size="sm"
                className="bg-white text-purple-600 hover:bg-white/90 font-semibold text-xs h-8 px-3 animate-[pulse_2s_ease-in-out_infinite]"
              >
                {announcement.cta_text}
                <ExternalLink className="h-3 w-3 ml-1" />
              </Button>
            </a>
          )}
          <Button
            variant="ghost"
            size="icon"
            className="h-7 w-7 text-white/70 hover:text-white hover:bg-white/10"
            onClick={onDismiss}
            data-testid="announcement-dismiss"
          >
            <X className="h-3.5 w-3.5" />
          </Button>
        </div>
      </div>
    </div>
  );
}
